import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId } from "./constants.js";
import { useHover } from "./hooks/useHover.js";
import ChevronRight from "./components/Icons/ChevronRight.js";
import { r as renderListHeader } from "./ListHeader.js";
import LinkListStyles from "./components/LinkList/styles.module.scss";
const Link = React__default.forwardRef((props, ref) => {
  const {
    children,
    className = "",
    color = "white",
    icon,
    size = "medium",
    chevron = false,
    linkRef,
    testId,
    target,
    variant,
    htmlMarkup = "a",
    ...restProps
  } = props;
  const { hoverRef, isHovered } = useHover(linkRef);
  const isFill = variant === "fill";
  const isFillNegative = variant === "fill-negative";
  const isOutline = variant === "outline";
  const isLine = variant === "line";
  const liClasses = classNames({
    [LinkListStyles["link-list__list-item--line"]]: isLine,
    [LinkListStyles[`link-list__list-item--outline--${color}`]]: isOutline
  });
  const linkClasses = classNames(
    LinkListStyles["link-list__anchor"],
    LinkListStyles[`link-list__anchor--${color}`],
    {
      [LinkListStyles[`link-list__anchor--line--${color}`]]: isLine,
      [LinkListStyles["link-list__anchor--fill"]]: isFill,
      [LinkListStyles[`link-list__anchor--fill--${color}`]]: isFill,
      [LinkListStyles["link-list__anchor--outline"]]: isOutline,
      [LinkListStyles[`link-list__anchor--outline--${color}`]]: isOutline,
      [LinkListStyles["link-list__anchor--fill-negative"]]: isFillNegative,
      [LinkListStyles[`link-list__anchor--${size}`]]: size,
      [LinkListStyles["link-list__anchor--button"]]: htmlMarkup === "button"
    },
    className
  );
  return /* @__PURE__ */ jsxs("li", { className: liClasses, ref, "data-testid": testId, "data-analyticsid": AnalyticsId.Link, children: [
    htmlMarkup === "a" && /* @__PURE__ */ jsx(
      "a",
      {
        className: linkClasses,
        ref: hoverRef,
        rel: target === "_blank" ? "noopener noreferrer" : void 0,
        target,
        ...restProps,
        children: renderListHeader(children, "span", isHovered, size, chevron ? ChevronRight : void 0, icon)
      }
    ),
    htmlMarkup === "button" && /* @__PURE__ */ jsx("button", { className: linkClasses, ref: hoverRef, type: "button", ...restProps, children: renderListHeader(children, "span", isHovered, size, chevron ? ChevronRight : void 0, icon) })
  ] });
});
const LinkList = React__default.forwardRef(function LinkListForwardedRef(props, ref) {
  const { children, className = "", chevron = false, size = "medium", color, testId, variant = "line" } = props;
  return /* @__PURE__ */ jsx("ul", { ref, className: classNames(LinkListStyles["link-list"], className), "data-testid": testId, "data-analyticsid": AnalyticsId.LinkList, children: React__default.Children.map(children, (child) => {
    if (child.type === Link) {
      return React__default.cloneElement(child, { color, size, chevron, variant });
    }
  }) });
});
LinkList.displayName = "LinkList";
LinkList.Link = Link;
Link.displayName = "LinkList.Link";
export {
  LinkList as L
};
//# sourceMappingURL=LinkList.js.map
